import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import CommentDashboard from './pages/CommentDashboard';
import UseRecord from './pages/UseRecord';
import BiliConfig from './pages/BiliConfig';
import CopyTextManagement from './pages/CopyTextManagement';
import AnnouncementManagement from './pages/AnnouncementManagement';
import VideoManagement from './pages/VideoManagement';
import PlayDashboard from './pages/PlayDashboard';
import StatVideoDashboard from './pages/StatVideoDashboard';

const theme = createTheme({
  palette: {
    primary: { main: '#00a1d6' },
    secondary: { main: '#fb7299' },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requiredPermission="bili_barrage"><Dashboard /></ProtectedRoute>} />
            <Route path="/commentDashboard" element={<ProtectedRoute requiredPermission="bili_comment"><CommentDashboard /></ProtectedRoute>} />
            <Route path="/playDashboard" element={<ProtectedRoute requiredPermission="bili_play"><PlayDashboard /></ProtectedRoute>} />
            <Route path="/statVideoDashboard" element={<ProtectedRoute requiredPermission="bili_play"><StatVideoDashboard /></ProtectedRoute>} />
            <Route path="/bili-config" element={<ProtectedRoute requiredRole={['admin']}><BiliConfig /></ProtectedRoute>} />
            <Route path="/copy-texts" element={<ProtectedRoute requiredRole={['admin']}><CopyTextManagement /></ProtectedRoute>} />
            <Route path="/announcements" element={<ProtectedRoute requiredRole={['admin']}><AnnouncementManagement /></ProtectedRoute>} />
            <Route path="/videos" element={<ProtectedRoute requiredRole={['admin']}><VideoManagement /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute requiredRole={['admin']}><UserManagement /></ProtectedRoute>} />
            <Route path="/use-records" element={<ProtectedRoute><UseRecord /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
